import { useMutation } from '@tanstack/react-query';
import { CouponApiV2 } from '../../../lib/api/coupon/CouponApiV2';
import toastMsg from '../../../lib/toastMsg';
import couponToastMsg from '../../../constants/service/toastMsg/couponToastMsg';
import { reDirectPage, setDetailPageUrl } from '../../../lib/common';
import { COUPON_DETAIL_URL_PATH } from '../../../constants/service/common/urlConstants';

type EditCouponPayload = {
  couponId: number | null;
  [key: string]: unknown;
};

export const useEditCouponMutation = () => {
  return useMutation({
    mutationFn: (data: EditCouponPayload) => CouponApiV2.editCoupon(data),
    onSuccess: (result, variables) => {
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.EDIT_COUPON_REQUEST_SUCCESS);
        if (variables.couponId != null) {
          reDirectPage({ path: setDetailPageUrl(COUPON_DETAIL_URL_PATH, variables.couponId) });
        }
      }
    },
    onError: (error: Error) => {
      toastMsg.error(couponToastMsg.EDIT_COUPON_REQUEST_ERROR, error);
    },
  });
};
